import { AlertTriangle, WifiOff, ShieldAlert, FileQuestion } from 'lucide-react';
import { Button } from './Button';
import { cn } from '@repo/utils';
import { AppError, getErrorMessage } from '@repo/i18n';

interface ErrorStateProps {
  error: AppError;
  retry?: () => void;
  className?: string;
}

export function ErrorState({ error, retry, className }: ErrorStateProps) {
  const Icon = getIconForError(error.category);
  const message = getErrorMessage(error);

  return (
    <div
      role="alert"
      className={cn(
        'error flex flex-col items-center justify-center gap-3 p-8 text-center bg-surface-1 rounded-md border border-border',
        className
      )}
    >
      <div className="text-danger-500 mb-1">
        <Icon size={24} />
      </div>
      <p className="text-sm font-semibold text-text-primary">
        {error.category === 'network' ? 'Connection Error' : 'Error'}
      </p>
      <p className="text-xs text-text-muted max-w-xs">{message}</p>
      {retry && (
        <Button variant="primary" size="sm" onClick={retry} className="mt-2">
          Try Again
        </Button>
      )}
    </div>
  );
}

function getIconForError(category: AppError['category']) {
  switch (category) {
    case 'network':
      return WifiOff;
    case 'forbidden':
    case 'unauthorized':
      return ShieldAlert;
    case 'not-found':
      return FileQuestion;
    default:
      return AlertTriangle;
  }
}
